import { IAppState } from '../../AppModulesWrapper';
import { selectActivePlacingType, selectPaidPublication } from '../reducers/v2/paidPublication/selectors';
import { selectActivePackage } from '../reducers/v2/publicationPackages/selectors';
import { EPlacingType, EServiceId, EServiceType } from '../types/reducers/publishTerms';
import { EMoneySource } from '../types/reducers/user';
import { IPaidPublicationState } from '../reducers/v2';
import { IPackage } from '../reducers/v2/publicationPackages/types';
import { ITariffIdentificator } from '../reducers/v2/paidPublication/types';
import { selectActiveService } from '../selectors/publishTerms';
import { selectPlacingMoneySource } from '../reducers/v2/moneySources/selectors';
import { selectAuctionBet, selectCurrentBet, selectTermsDurationInDays } from '../reducers/v2/promotion/selectors';
import { mapInternalServiceTypes } from './publishTerms';
import { EServiceTypes } from '../repositories/billing-tariffs/entities/Models/TariffIdentificator';

export interface ICheckPublishTermWithMoneySource extends ICheckPublishTermSchema {
  moneySource?: EMoneySource | null;
}

export function getPublishTerms(state: IAppState): ICheckPublishTermWithMoneySource[] {
  const placingType = selectActivePlacingType(state);
  const publication = selectPaidPublication(state);
  const publicationPackage = selectActivePackage(state);
  const activeService = selectActiveService(state);
  const auctionBet = selectCurrentBet(state);
  const auction = selectAuctionBet(state);
  const moneySource = selectPlacingMoneySource(state);
  const durationInDays = selectTermsDurationInDays(state);

  const result: ICheckPublishTermWithMoneySource[] = [];

  if (placingType === EPlacingType.balance && publication) {
    const mappedTerm = mapTerm(publication);

    result.push(mappedTerm);
  }

  if (placingType === EPlacingType.package && publicationPackage) {
    const mappedTerm = mapTerm(publicationPackage);

    result.push(mappedTerm);
  }

  if (activeService) {
    const type = durationInDays > 1 ? 'periodical' : 'dailyTermless';

    const term = {
      type,
      days: durationInDays,
      services: [EServiceType.Auction],
      tariffIdentificator: {
        days: 1,
        periodType: 'DailyTermless',
        serviceTypes: ['auction'] as EServiceTypes[],
        tariffGridType: 'DynamicPricing',
        tariffId: 210,
      },
      dynamicPrice: activeService.type === EServiceId.top && auctionBet ? auctionBet : activeService.price,
      token: auction.token,
    };

    result.push(term);
  }

  // Добавляем moneySource для каждого элемента, нужно для выбора счёта однократного размещения
  if (moneySource) {
    result.forEach(term => {
      term.moneySource = moneySource;
    });
  }

  return result;
}

function mapTerm(term: IPaidPublicationState | IPackage): ICheckPublishTermSchema {
  return {
    type: term.type!,
    days: term.days,
    services: mapInternalServiceTypes<EServiceType>(term.tariffIdentificator?.serviceTypes || []),
    tariffIdentificator: term.tariffIdentificator,
    token: term.token,
  };
}

export interface ICheckPublishTermSchema {
  // Тип периода публикации
  type?: string;
  // Применяемые услуги
  services: EServiceType[];
  // Количество дней публикации
  days: number;
  // Тариф
  tariffIdentificator?: ITariffIdentificator;
  // id рекомендованного пакета размещения (для услуги "Оптом дешевле")
  recommendedServicePackageId?: number;
  // ставка аукциона
  dynamicPrice?: number;
  /** Токен услуги **/
  token?: string | null;
}
